export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q02_b.a8b4d242.png";